import { render, staticRenderFns } from "./TipoDescontoConsulta.vue?vue&type=template&id=4e0765c0&"
import script from "./TipoDescontoConsulta.vue?vue&type=script&lang=js&"
export * from "./TipoDescontoConsulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports